// extracted by mini-css-extract-plugin
export default {"spriteAnimation":"pearAnimation_spriteAnimation__aOoCH","frame":"pearAnimation_frame__Z-Fdt","visible":"pearAnimation_visible__+QZit","hidden":"pearAnimation_hidden__5-B35"};